// FIXME: semua form yg perlu sanitize pake code ini,
// hnya saja blom bisa handle child object
// kalo child array of object sudah bisa
// fungsinya untuk menghilangkan object key
// yg bernilai null atau empty string
const sanitizeData = (data) => {
  const sanitizedData = {};
  for (const key in data) {
    // React-admin ArrayInput can leave untouched fields as undefined.
    // Omitting them prevents empty nested rows such as [{}] from reaching
    // backend validation.
    if (data[key] === undefined) continue;
    if (typeof data[key] === "string" && data[key].trim().length === 0)
      continue;
    if (data[key] === null) continue;
    // cek child
    if (Array.isArray(data[key])) {
      sanitizedData[key] = [];
      for (let i = 0; i < data[key].length; i++) {
        const elm = data[key][i];
        sanitizedData[key][i] = sanitizeData(elm);
      }
      // cek child
    } else {
      sanitizedData[key] = data[key];
    }
  }

  // TADINYA LANGSUNG RETURN sanitizedData, KEMUDIAN ADA KEPERLUAN HAPUS EMPTY OBJECT
  // JD DITAMBAH CODE NYA DIBAWAH INI

  const sanitizedEmptyObject = {};

  for (const key in sanitizedData) {
    if (Array.isArray(sanitizedData[key])) {
      sanitizedEmptyObject[key] = [];
      for (let i = 0; i < sanitizedData[key].length; i++) {
        const elm = sanitizedData[key][i];
        if (elm.constructor === Object && Object.keys(elm).length === 0) {
          // hapus empty object di dalam array: [{}] jadi []
          continue;
        }
        sanitizedEmptyObject[key][i] = elm;
      }
      // cek child
    } else {
      sanitizedEmptyObject[key] = sanitizedData[key];
    }
  }

  return sanitizedEmptyObject;
};
export default sanitizeData;
